// カート内件数表示

/**
 * @typedef CartItem - cartプロパティに入っている商品情報
 * @property {string} hinbng
 * @property {string} hinbng_class
 * @property {string} hjihinbng
 * @property {string} phinbng
 * @property {number} suryo
 * @property {string} title
 * @property {number} total
 * @property {string} zaiko
 * @property {number} zkmpri
 * @property {number} znkpri
 */

/**
 * @typedef CartAPIResponse - JSOPでCallback関数が受け取るAPIの返り値
 * @property {string} link
 * @property {string} title
 * @property {CartItem[]} cart
 */

// import global variables.
import {BODY_ELEMENT, randomString} from '../utils/global';

/**
 * jsonp - JSONPの取得とcallbackの設定
 * @return {Promise<CartAPIResponse>}     [description]
 */
const jsonp = () => new Promise((resolve) => {
    const name = `callback${randomString()}`;
    const script = document.createElement('script');

    script.id = name;
    script.src = `https://shopweb.ponycanyon.co.jp/cgi-cst/PCSCW01/get_cart_info.pl?TRGID=PCSCW0103&CMD=DSP&SYSKBN=Z21&callback=${name}`;

    // callback処理の登録
    window[name] = (data) => {
        resolve(data);

        // 実行後script要素とcallback処理を削除
        BODY_ELEMENT.removeChild(document.getElementById(name));
        window[name] = {};
    };

    BODY_ELEMENT.appendChild(script);
});

/**
 * updateCartIcon - カートアイコンの件数を更新する
 * @param  {HTMLElement} iconElement カートアイコンの要素
 * @param  {Number} itemLength  カートが持つ商品の件数
 * @return {Void}
 */
const updateCartIcon = (iconElement, itemLength) => {
    const numberText = iconElement.querySelector('.c-header-icon--cart__num');
    const isOverHoundred = itemLength >= 100;

    if (!numberText) {
        return;
    }

    // 0件ではない場合、`.is-empty`を削除
    if (itemLength !== 0) {
        iconElement.removeAttribute('class');
    }

    // 100件を超える場合、`.is-over`を付与
    if (isOverHoundred) {
        iconElement.setAttribute('class', 'is-over');
    }

    // 個数を更新
    numberText.textContent = isOverHoundred ? '99' : `${itemLength}`;
};

/**
 * デフォルト実行処理
 * @return {void}
 */
export default () => {
    const targetIcon = document.getElementById('icon-cart');

    // カートアイコンが見つからない場合、何もしない
    if (!targetIcon) {
        return;
    }

    // APIからJSONPを取得・処理
    jsonp().then((json) => {
        const cartItem = json.hasOwnProperty('cart') ? json.cart : [];
        let cartItemLength = 0;

        // カート内に何も商品が登録されていない場合、0件としてアイコンを更新
        if (!cartItem.length) {
            updateCartIcon(targetIcon, cartItemLength);

            return;
        }

        // カート内の商品の件数の合計値を取得
        for (const item of cartItem) {
            if (!item.hasOwnProperty('suryo')) {
                continue;
            }

            cartItemLength += parseInt(item.suryo, 10);
        }

        // アイコンを更新
        updateCartIcon(targetIcon, cartItemLength);
    });
};
